import {
  withTranslation,
} from 'react-i18next';

import AdminChampionshipDocumentsSectionView from './AdminChampionshipDocumentsSectionView';

const TranslatedComponent = withTranslation()(AdminChampionshipDocumentsSectionView);

const Component = TranslatedComponent;

export default Component;
